import { create } from 'zustand';
import type { Me, Workspace, WorkspaceMembership } from '@/lib/api/types';
import { writeLS } from './ui';

export type Principal =
  | { kind: 'member'; memberId: string; mask: number }
  | { kind: 'share'; token: string; mask: number; guestName: string | null }
  | { kind: 'guest-upload'; token: string; mask: number }
  | { kind: 'anonymous'; mask: 0 };

type SessionState = {
  me: Me | null;
  workspace: Workspace | null;
  membership: WorkspaceMembership | null;
  principal: Principal;
  /** board id → effective mask, filled from board/asset responses (§6.4). */
  boardMasks: Record<string, number>;
  setMe: (me: Me | null) => void;
  setWorkspace: (ws: Workspace | null, membership: WorkspaceMembership | null) => void;
  setPrincipal: (p: Principal) => void;
  rememberBoardMask: (boardId: string, mask: number | undefined) => void;
  setShareGuestName: (name: string) => void;
};

export const useSessionStore = create<SessionState>((set) => ({
  me: null,
  workspace: null,
  membership: null,
  principal: { kind: 'anonymous', mask: 0 },
  boardMasks: {},
  setMe: (me) => set({ me }),
  setWorkspace: (workspace, membership) => {
    if (workspace) writeLS('lastWorkspaceSlug', workspace.slug);
    set({
      workspace,
      membership,
      principal: membership
        ? { kind: 'member', memberId: membership.member_id, mask: Number(membership.effective_mask) }
        : { kind: 'anonymous', mask: 0 },
    });
  },
  setPrincipal: (principal) => set({ principal }),
  rememberBoardMask: (boardId, mask) => {
    if (mask == null) return;
    set((s) => (s.boardMasks[boardId] === Number(mask) ? s : { boardMasks: { ...s.boardMasks, [boardId]: Number(mask) } }));
  },
  setShareGuestName: (guestName) =>
    set((s) => (s.principal.kind === 'share' ? { principal: { ...s.principal, guestName } } : s)),
}));
